import { from, Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { DOM_STRATEGY, DomInsertionService, StyleContentStrategy, ScriptContentStrategy, LazyLoadService, LOADING_STRATEGY } from '@abp/ng.core';
import { LayoutStateService } from '../services/layout-state.service';
import { Injector } from '@angular/core';

import { css as metronicStyle } from '../../assets/metronic1/styles';

export const getMetronicStyle = (type: number): Observable<string> => {
	return from([metronicStyle]);
};


export function setStyle(styleNumber: number, injector: Injector) {
	const layoutState = injector.get(LayoutStateService);
	if (layoutState.get('style') === styleNumber || typeof styleNumber !== 'number') {

		return;
	}

	const styleElement = layoutState.get('styleElement');
	removeMetronicStyles(styleElement, injector);
	loadMetronicStyle(styleNumber, injector)
		.pipe(take(1))
		.subscribe(element => {
			element && element.setAttribute('class', 'metronic');
			layoutState.patch({ style: styleNumber, styleElement: element });
		});
}

export function loadMetronicStyle(type: number, injector: Injector): Observable<HTMLStyleElement> {
	const domInsertionService = injector.get(DomInsertionService);
	const bootstrap: HTMLLinkElement = document.querySelector('link[href*=bootstrap]');
	const domStrategy = bootstrap
		? DOM_STRATEGY.AfterElement(bootstrap)
		: DOM_STRATEGY.AppendToHead();

	return getMetronicStyle(type).pipe(
		map(content => {
			const strategy = new StyleContentStrategy(content, domStrategy);
			return domInsertionService.insertContent(strategy);
		}),
	);
}


export function removeMetronicStyles(element: HTMLStyleElement, injector: Injector) {
	const domInsertionService = injector.get(DomInsertionService);

	if (element) {
		domInsertionService.removeContent(element);
	}
}
